import Breadcrumbs from "../../../components/breadcrumbs/Breadcrumbs";
import { DynamicFilterConfig } from "../../../components/DynamicComponent/DynamicFilterPanel";
import GridTable from "../../../components/GridTable/GridTable";
import endpoints from "../../../services/endpoints";
import { useNavigate, useParams } from "react-router";
import { RootState } from "../../../store";
import { useSelector } from "react-redux";

export default function ListOfMnoTransactions() {
    const navigate = useNavigate();
    const { mnoTransactions } = endpoints;
    const { id } = useParams();
    const pathname = useSelector((state: RootState) => state.selectedBankId.listOfUsers);
    const etopupTableDetails: { [key: string]: any } = {
      "Transaction ID": {
        id: "transaction_id",
      },
      "Reversal Date and Time": {
        id: "reversal_date",
        custom: ["reversal_date"],
      },
      Description: {
        id: "description",
        className: "min-w-[400px]",
      },
      "Transaction Type": {
        id: "transaction_type",
      },
      "Recharged Phone Number": {
        id: "recharged_phone_number",
        custom: ["recharged_phone_number"],
      },
      Debit: {
        id: "debit",
        custom: ["debit"],
      },
      Credit: {
        id: "credit",
        custom: ["credit"],
      },
      Balance: {
        id: "balance",
        custom: ["balance"],
      },
    };

    const handleActions = async (id: string, key: string, text?: any) => {
        navigate(`/zoodpay-money/recharge-reversal/${id}`);
    };
    const staticText = {
        emptyScreenText: {
            heading1: "No Data",
            heading2: "No records found.",
        },
    };
    const dynamicFilterConfig: DynamicFilterConfig = {
        "Date Range": {
            label: "Date Range",
            type: "date",
            required: false,
            searchKey: {
                start: "reversal_start_date",
                end: "reversal_end_date",
            },
        },
    }
    return (
        <>
            <Breadcrumbs
                navPath={[
                    "Zoodpay Money",
                    "Reversals",
                    `List of Reversals`,
                    "List of Recharge Reversal Transactions",
                ]}
                heading={`List of Recharge Reversal Transactions`}
                links={[
                    pathname ? pathname : "/zoodpay-money/super-admin-transactions",
                    pathname ? pathname : "/zoodpay-money/super-admin-transactions",
                    pathname ? pathname : "/zoodpay-money/super-admin-transactions",
                ]}
            />
            <GridTable
                staticText={staticText}
                mainEndPoint={`${mnoTransactions}/${id}`}
                TableDetails={etopupTableDetails}
                handleActions={(id: string, key: string, text?: string) =>
                    handleActions(id, key, text)
                }
                params={{ page_number: "1" }}
                searchPlaceholder={`Search by transaction id`}
                filters={true}
                exporting={true}
                reportType="Balance Sheet"
                notfoundRoute={{
                    state: { route: `/zoodpay-money/reversals/recharge-reversal` },
                }}
                title={`List of Reversal Transactions`}
                hasViewMDPrivilege={true}
                addMorePadding={false}
                dynamicFilterConfig={dynamicFilterConfig}
                heightClassName="h-reversalsHeight"
                filterShimmer={true}
                customHeight="h-[103px]"
            />
        </>
    );
}
